import useCustomTranslation from 'hooks/useCustomTranslation'
import { StyledH2, Subtext } from 'pages/InfoRequestPage.styles'
import { ComponentInterface } from 'typings'
import { isCalifornia, isWashington } from 'helpers/states'
import { ParentRelationshipGrid } from '../RequestPage.styles'
import CaliforniaOptions from './California'
import WashingtonOptions from './Washington'

const RequestType = ({
  formValues,
  handleOnChange,
  ...rest
}: ComponentInterface): JSX.Element => {
  const t = useCustomTranslation('form')

  return (
    <>
      <StyledH2 style={{ marginTop: '3rem', marginBottom: '-0.5rem' }}>
        {t('request.title')}
      </StyledH2>
      <Subtext style={{ color: '#c63527' }}>
        {formValues.requestTypeMissing && t('request.subtext')}
      </Subtext>
      <ParentRelationshipGrid>
        {isCalifornia(formValues.state.value) && (
          <CaliforniaOptions
            formValues={formValues}
            handleOnChange={handleOnChange}
            {...rest}
          />
        )}
        {isWashington(formValues.state.value) && (
          <WashingtonOptions
            formValues={formValues}
            handleOnChange={handleOnChange}
            {...rest}
          />
        )}
      </ParentRelationshipGrid>
    </>
  )
}

export default RequestType
